import { Link } from "react-router-dom";
import { SEOHead } from "../components/SEOHead";
import { PublicHeader } from "../components/PublicHeader";
import "../styles/PublicCommon.css";
import "./NotFoundPage.css";

// 公開側の 404 ページ。
// nginx は未知の URL に 404 ステータスでこの SPA を返す。クライアント遷移で来た場合に備えて
// noindex も付け、canonical は出さない。
export const NotFoundPage = () => {
  return (
    <>
      <SEOHead title="ページが見つかりません" noIndex />

      <div className="public-page">
        <PublicHeader />

        <main id="main-content" role="main">
          <section className="page-header">
            <div className="page-header-overlay" />
            <div className="page-header-content">
              <h1 className="page-title">ページが見つかりません</h1>
              <p className="page-subtitle">404 Not Found</p>
            </div>
          </section>

          <section className="not-found-section">
            <div className="container-narrow">
              <p>
                お探しのページは移動または削除された可能性があります。
                <br />
                URLをご確認いただくか、トップページからお探しください。
              </p>
              <Link to="/" className="not-found-link">
                トップページへ戻る
              </Link>
            </div>
          </section>
        </main>
      </div>
    </>
  );
};

export default NotFoundPage;
